import PageHandlersService from '@/utils/page-handlers-service';

const pageHandlers = new PageHandlersService();

const init = () => {
    const popup = document.querySelector('.js-contact-popup');
    const openButtons = document.querySelectorAll('.js-open-contact-popup');
    const closeButtons = document.querySelectorAll('.js-contact-popup-close');

    if (popup) {
        openButtons.forEach((button) => {
            pageHandlers.set(button, () => {
                popup.classList.add('active');
            });
        });

        closeButtons.forEach((button) => {
            pageHandlers.set(button, () => {
                popup.classList.remove('active');
            });
        });
    }
};

const destroy = () => pageHandlers.clear();

const _module = { init, destroy };

export default _module;
